export default class setor{
    _id;
    _ativo;
    _codigoSetor;
    _descricao;

    get id() {
        return this._id;
    }
    set id(value) {
        this._id = value;
    }

    get ativo() {
        return this._ativo;
    }
    set ativo(value) {
        this._ativo = value;
    }

    get codigoSetor() {
        return this._codigoSetor;
    }
    set codigoSetor(value) {
        this._codigoSetor = value;
    }

    get descricao() {
        return this._descricao;
    }
    set descricao(value) {
        this._descricao = value;
    }

    constructor(pId,pAtivo,pCodigoSetor,pDescricao){
        this.id = pId;
        this.ativo = pAtivo;
        this.codigoSetor = pCodigoSetor;
        this.descricao = pDescricao;
    }
}